<div id="snack-container" #snackbar></div>

